import { MessageProp } from "@/context/redux/reducers/chat-slice";
import { Translation } from "@/data/lang";

import { DefaultQuestions } from "../components/session-widgets/DefaultQuestions";

export const getPresetSessionMap = ({
  t,
}: {
  t: Translation;
}): Record<string, MessageProp[]> => ({
  default: [
    {
      type: "gpt",
      content: t.winwingpt.sessions.askQuestion,
    },
    {
      type: "element",
      content: <DefaultQuestions />,
    },
  ],
});
